import { render, staticRenderFns } from "./NewLogin.vue?vue&type=template&id=16cceb5a&scoped=true"
import script from "./NewLogin.vue?vue&type=script&lang=js"
export * from "./NewLogin.vue?vue&type=script&lang=js"
import style0 from "./NewLogin.vue?vue&type=style&index=0&id=16cceb5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cceb5a",
  null
  
)

export default component.exports